<template>
  <div class="fill-parent-container">
    <div class="centered">
      <textarea
        class="container-answer noselect"
        id="answerWithButton"
        :value="answerLocal"
        autoFocus
        rows="1"
      >
      </textarea>
      <done-button
        v-if="answerLocal && answerLocal.trim().length > 0"
        :class="['done-button', answerLocal ? '' : 'hidden']"
        :on-click="done"
        :transition="innerTransition"
        text="Done"
      >
      </done-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import DoneButton from 'components/activity/DoneButton.vue';

const typingActivityNamespace = createNamespacedHelpers('activity/typing');
const LIMIT = 3000;
const BACKSPACE = 'backspace';
const ENTER = 'enter';
const TAB = 'tab';

export default {
  components: {
    DoneButton
  },
  props: {
    doneCallback: {
      type: Function,
      required: true
    },
    answer: {
      required: false
    }
  },
  mixins: [TypingActivityHelper],

  data() {
    return {
      answerLocal: '',
      innerTransition: 'fade-10',
      wasDoneButtonPressed: false
    };
  },

  created() {
    this.answerLocal = this.answer || ' ';
    this.setFreeTextTyping(true);
  },

  mounted() {
    const answerDOM = document.getElementById('answerWithButton');
    if (answerDOM) answerDOM.focus();
  },

  methods: {
    ...typingActivityNamespace.mapMutations(['setFreeTextTyping']),

    fitToContent(textElement, maxHeight) {
      if (!textElement) return;

      if (textElement.clientHeight == textElement.scrollHeight) {
        textElement.style.height = '30px';
      }

      let adjustedHeight = textElement.clientHeight;
      if (!maxHeight || maxHeight > adjustedHeight) {
        adjustedHeight = Math.max(textElement.scrollHeight, adjustedHeight);
        if (maxHeight) adjustedHeight = Math.min(maxHeight, adjustedHeight);
        if (adjustedHeight > textElement.clientHeight)
          textElement.style.height = adjustedHeight + 'px';
      }
    },

    handleCorrectKey(attempt) {
      const { character } = attempt;

      if (this.wasDoneButtonPressed) {
        return;
      }

      const lowerChr = character.toLowerCase();
      const tabOrEnter = lowerChr === TAB || lowerChr === ENTER;
      if (tabOrEnter || this.answerLocal.length === LIMIT) {
        // skip if ENTER or if maximum character limit has been reached
        return;
      }

      if (lowerChr === BACKSPACE) {
        // remove last character if backspace
        this.answerLocal = this.answerLocal.slice(0, -1) || ' ';
      } else {
        if (this.answerLocal === ' ') {
          this.answerLocal = '';
        }
        // append character
        this.answerLocal = `${this.answerLocal}${character}`;
      }

      this.incrementTypingIndex();

      this.captureKeyboardAttemptSegment(attempt, this.isEndOfCurrentSentence);

      this.$nextTick(() => {
        // this will be replaced in vue2 with $refs
        const answerDOM = document.getElementById('answerWithButton');
        answerDOM.scrollTop = answerDOM.offsetHeight;
        this.fitToContent(answerDOM, 130);
      });
    },

    done() {
      this.wasDoneButtonPressed = true;
      this.doneCallback(this.answerLocal);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkmark-icon {
  vertical-align: top;
  display: inline-block;
  margin-left: 15px;
}

.fill-parent-container {
  max-width: 100%;
  max-height: 180px;
  overflow: hidden;
  margin: 0 auto;
}

.container-answer {
  width: calc(100% - 80px);
  display: inline-block;
  border: 2px solid #000;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 30px;
  font-family: 'hwtfutura';
  box-sizing: border-box;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  height: 55px;
  min-height: 55px;
  max-height: 130px;
  max-width: 90%;
}

.container-done {
  display: flex;
  flex-direction: column;
  flex-basis: 60px;
  flex-shrink: 0;
  margin: auto;
  color: green;
}

@keyframes blinky {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.centered {
  margin: 0 auto 0 auto;
  width: 100%;
}
</style>
